import React from 'react';
import { FaArrowLeft, FaCheckCircle } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Payment() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const userId = searchParams.get('usr') || '';
  return (
    <main className="min-h-screen bg-white">
      <div className="h-14 flex items-center px-4">
        <button
          onClick={() => navigate(`/?usr=${userId}`)}
          className="flex items-center text-gray-700"
        >
          <FaArrowLeft className="mr-2" />
          <span>Kembali Ke Beranda</span>
        </button>
      </div>
      <div className="flex flex-col items-center justify-center h-[calc(100vh-56px)] px-4 text-center">
        <FaCheckCircle size={48} className="text-green-500 mr-2 mb-1" />
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          AKTIVASI BERHASIL!
        </h1>
        <p className="text-gray-700 mb-6">
          Terima kasih sudah menggunakan layanan Smartsecure. Paket layanan anda
          telah diaktifkan.
        </p>
        <button
          onClick={() => navigate(`/?usr=${userId}`)}
          className="px-6 py-3 bg-[#3723B5] text-white rounded-lg hover:bg-[#d91a54] transition-colors"
        >
          Kembali ke Beranda
        </button>
      </div>
    </main>
  );
}
